import type { TypographyVariantsOptions } from '@mui/material/styles';

const bodyFont = ['Mukta Mahee', 'Helvetica Neue', 'Arial', 'sans-serif'].join(',');
const headingFont = ['TDC', bodyFont].join(',');

function rem(number: number | string, base = 16): string {
  if (typeof number === 'string') {
    number = parseInt(number, 10);
  }

  return `${number / base}rem`;
}

export const typography: TypographyVariantsOptions = {
  fontFamily: bodyFont,
  h1: {
    fontFamily: headingFont,
    fontSize: rem(80),
    letterSpacing: rem(-1.5),
    lineHeight: 1.2,
  },
  h2: {
    fontFamily: headingFont,
    fontSize: rem(50),
    letterSpacing: rem(-0.5),
  },
  h3: {
    fontFamily: headingFont,
    fontSize: rem(35),
    fontWeight: 700,
    lineHeight: 1.3,
  },
  h4: {
    fontFamily: headingFont,
    fontSize: rem(30),
    fontWeight: 300,
    letterSpacing: rem(0.25),
    lineHeight: 1.3,
  },
  h5: {
    fontFamily: headingFont,
    fontSize: rem(20),
    fontWeight: 700,
    lineHeight: 1.3,
  },
  h6: {
    fontFamily: headingFont,
    fontSize: rem(15),
    fontWeight: 700,
    letterSpacing: rem(0.15),
    lineHeight: 1.3,
    textTransform: 'uppercase',
  },
  subtitle1: {
    fontFamily: bodyFont,
    fontWeight: 600,
    lineHeight: 1.125,
    fontSize: rem(16),
  },
  subtitle2: {
    fontFamily: bodyFont,
    fontWeight: 600,
    letterSpacing: rem(0.1),
    lineHeight: 1.3,
    fontSize: rem(14),
  },
  body1: {
    fontFamily: bodyFont,
    fontWeight: 300,
    letterSpacing: rem(0.16),
    lineHeight: 1.5,
  },
  body2: {
    fontFamily: bodyFont,
    fontWeight: 300,
    letterSpacing: rem(0.14),
    lineHeight: 1.3,
  },
  button: {
    fontFamily: bodyFont,
    fontSize: rem(16),
    fontWeight: 500,
    letterSpacing: rem(0.16),
    lineHeight: 1.3,
    textTransform: 'none',
  },
  caption: {
    fontFamily: bodyFont,
    fontSize: rem(13),
    fontWeight: 300,
    letterSpacing: rem(0.13),
    lineHeight: 1.3,
  },
  overline: {
    fontFamily: bodyFont,
    fontSize: rem(11),
    fontWeight: 300,
    letterSpacing: rem(1.1),
    lineHeight: 1.3,
    textTransform: 'uppercase',
  },
};
